import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-confirm-popup',
  standalone: true,
  imports: [NzButtonModule, NzModalModule],
  templateUrl: './confirm-popup.component.html',
  styleUrl: './confirm-popup.component.scss'
})
export class ConfirmPopupComponent {
  @Input() title: string = 'Confirm';
  @Input() message: string = 'Are you sure you want to proceed?';
  @Input() confirmText: string = 'Yes';
  @Input() cancelText: string = 'No';
  @Input() triggerModal:boolean = false;
  @Input() modalwidth:string = '520px';

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  constructor(private modal: NzModalService) { }

   ngOnInit(): void { }

   ngOnChanges(changes:SimpleChanges){
    if(this.triggerModal)
    this.showDeleteConfirm();
   }

  showDeleteConfirm(): void {
    this.modal.confirm({
      nzTitle: '<b>' + this.title  + '</b>',
      nzContent: this.message,
      nzOkText: this.confirmText,
      nzWidth: this.modalwidth,
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.onConfirm(),
      nzCancelText: this.cancelText,
      nzOnCancel: () => this.onCancel(),
      nzCentered: true
    });
  }

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
